import { Component, Input } from '@angular/core';
import { ParkourDividerComponent, ParkourPageGradientComponent } from '@parkour/ui';

@Component({
  selector: 'parkour-page-with-gradient-hero',
  standalone: true,
  imports: [ParkourDividerComponent, ParkourPageGradientComponent],
  templateUrl: './page-with-gradient-hero.component.html',
})
export class PageWithGradientHeroComponent {
  @Input({ required: true }) title!: string;
}
